import { render, staticRenderFns } from "./systemDrawer.vue?vue&type=template&id=129035b0&scoped=true"
import script from "./systemDrawer.vue?vue&type=script&lang=js"
export * from "./systemDrawer.vue?vue&type=script&lang=js"
import style0 from "./systemDrawer.vue?vue&type=style&index=0&id=129035b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129035b0",
  null
  
)

export default component.exports